import React, { useCallback } from 'react';
import get from 'lodash.get';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import TagButton from '../../components/grid-header/tag-button';
import { emptyArray } from 'ui-components/default-props/empty';
import * as CustomerActions from '../../store/customers/customers.actions';
import Global from '../../store/global-selectors';

const getSelectedData = (customers) => {
  const selectedTagIds = new Set();
  const selectedTagsCount = {};
  customers.forEach((customer) => {
    const customerTags = get(customer, 'tagIds', emptyArray);
    customerTags.forEach((tag) => {
      selectedTagIds.add(tag);
      if (selectedTagsCount[tag]) {
        selectedTagsCount[tag] += 1;
      } else {
        selectedTagsCount[tag] = 1;
      }
    });
  });
  return {
    selectedTagsCount,
    selectedTagIds: [...selectedTagIds],
  };
};

const selectedDataSelector = createSelector((customers) => customers, getSelectedData);

const selectedTagsSelector = createSelector(
  (tags) => tags,
  (_, selectedTagIds) => selectedTagIds,
  (tags, selectedTagIds) =>
    tags.filter(
      (tag) =>
        selectedTagIds.filter((tagId) => {
          return tagId && tagId.valueOf() === tag.tagId.valueOf();
        }).length !== 0,
    ),
);

const CustomersTagButton = () => {
  const dispatch = useDispatch();
  const addTag = useCallback((customerIds, tagId) => dispatch(CustomerActions.addTagsToCustomers(customerIds, tagId)), [dispatch]);
  const removeTag = useCallback((customerIds, tagId) => dispatch(CustomerActions.removeTagsFromCustomers(customerIds, tagId)), [dispatch]);

  const tags = useSelector(Global.selectSellerTags) || emptyArray;
  const selectedIds = useSelector(Global.selectSelectedCustomersIds) || emptyArray;
  const selectedIdsAsStrings = selectedIds.map((id) => String(id));
  const selectedCustomers = useSelector((state) => Global.selectEntitiesCustomersByIds(state, { customerIds: selectedIds })) || emptyArray;
  const shouldBeDisabled = !selectedIds.length;
  const { selectedTagsCount, selectedTagIds } = selectedDataSelector(selectedCustomers);
  const selectedTags = selectedTagsSelector(tags, selectedTagIds);

  return (
    <TagButton
      addTag={addTag}
      removeTag={removeTag}
      selectedIds={selectedIdsAsStrings}
      selectedTags={selectedTags}
      selectedTagsCount={selectedTagsCount}
      shouldBeDisabled={shouldBeDisabled}
      tags={tags}
    />
  );
};

export default CustomersTagButton;
